/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.heading[_ngcontent-%COMP%] {\n    line-height: 80px;\n    text-align: right;\n}\n.heading[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%] {\n    margin: 0;\n    margin-top:20px;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9hZG1pbi9jbGllbnRzL2NsaWVudC1lZGl0L2NsaWVudC1lZGl0LmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL3d3dy9odG1sL015RGVzaWduVjMvaHRtbC9zcmMvYXBwL2FkbWluL2NsaWVudHMvY2xpZW50LWVkaXQvY2xpZW50LWVkaXQuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/admin/clients/client-edit/client-edit.component.css.shim.ngstyle.ts